import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, throwError } from 'rxjs';
import { catchError } from 'rxjs/internal/operators';
import { AuthenticationService } from 'src/app/components/services/auth/authentication.service';
import { ProductsService } from 'src/app/components/services/products/products.service';
import { productDB } from 'src/app/shared/tables/product-list';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {

  public product_list = []
  public families: any;
  public totalProducts: number;
  private subs: Array<Subscription> = [];
  private modalContent: any;
  private modalConfig: any = {
    ariaLabelledBy: 'modal-basic'
  };

  public selectedFamily: string;
  public productDeleteSuccess = false;
  public productId: number;

  constructor(
    private productService: ProductsService,
    private authService: AuthenticationService,
    private modalService: NgbModal
  ) {
    // this.product_list = productDB.product;
  }

  ngOnInit() {
    this.subs.push(
      this.productService
        .getProducts()
        .pipe(
          catchError(err => this.authService.handleUnauthorizedError(err))
        )
        .subscribe(data => {
          this.product_list = data;
          this.totalProducts = this.product_list.length;
        })
    );
    this.productService
    .getFamilies()
    .subscribe(data => {
      this.families = data;
    })
  }

  public getProducts(): any {
    if(this.selectedFamily == 'Todas'){
      this.subs.push(
        this.productService
          .getProducts()
          .pipe(
            catchError(err => this.authService.handleUnauthorizedError(err))
          )
          .subscribe(data => {
            this.product_list = data;
            this.totalProducts = this.product_list.length;
          })
      );
    }else{
      this.subs.push(
        this.productService.getProductsFiltered(this.selectedFamily)
          .pipe(catchError(err => {
            return throwError(err);
          }))
          .subscribe(data => {
            this.product_list = data;
            this.totalProducts = this.product_list.length;
          })
      );
    }
  }

  public setModalContent(content: any, productId: number): void {
    this.productId = productId;
    this.modalContent = content;
    this.modalService.open(this.modalContent, this.modalConfig);
  }

  public deleteProduct() : void {
    this.subs.push(
      this.productService.deleteProduct(this.productId)
        .subscribe(resolve => {
          if (resolve.Active == false) {
            this.productDeleteSuccess = true;
            setTimeout(() => {
              this.modalService.dismissAll();
              window.location.reload();
            }, 1500);
          }
        })
    );
  }


}
